import SpriteSymbol from "../../../../../../../node_modules/normacs_web/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/normacs_web/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checkbox",
  "use": "checkbox-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 64 64\" id=\"checkbox\">\n  <path d=\"M32 2C15.5 2 2 15.5 2 32s13.5 30 30 30 30-13.5 30-30S48.5 2 32 2zm0 54C18.8 56 8 45.2 8 32S18.8 8 32 8s24 10.8 24 24-10.8 24-24 24z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol